import { render, staticRenderFns } from "./allowance.vue?vue&type=template&id=137924f6&scoped=true&"
import script from "./allowance.vue?vue&type=script&lang=js&"
export * from "./allowance.vue?vue&type=script&lang=js&"
import style0 from "./allowance.vue?vue&type=style&index=0&id=137924f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137924f6",
  null
  
)

export default component.exports